import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { TypeParams } from './types'

const ATTRIBUTES: readonly ec.models.Attribute<TypeParams>[] = [
  ec.models.Attribute.fromKey('code', { name: 'code' }),
  ec.models.Attribute.fromKey('name', { name: 'name' }),
  ec.models.Attribute.fromKey('isDirect', { name: 'isDirect' }),
]

@ngCore.Injectable()
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context =>
      context ? gql.queries.faFunctions.executor(context) : rxjs.of([]),
  )

  /** @inheritdoc */
  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of(ATTRIBUTES)
}
